<template>
  <div class="gsxw1 container">
    <div class="row justify-content-center" style="padding-top: 1.5rem;">
      <div class="gsxw col-lg-2 col-xl-3 ">
<!--        <div class="tit1 tit110"><a :href="'/article/list/'+newsNavId">公司新闻</a></div>
        <swiper
            :modules="modules"
            :pagination="{ clickable: true}"
            :effect="'slide'"
            :autoplay='{"delay": 5000}'
            class="swiper-wrapper2"
        >
          <swiper-slide v-for="item in banner1.leftData" :key="item.id" class="swiper-slide2">
            <a :href="'/article/detail/'+item.id"><img :src="base_url+item.cover.url"><span>{{item.title}}</span></a>
          </swiper-slide>
        </swiper>-->
        <div v-for="item in banner3.companyArticle" :key="item.id" class="gsjj1" >
          <div class="tit3 w100"><a href="">{{ item.nav.name }}</a></div>
          <div class="gsjj11" style="margin-top: 0">
            <a :href="'/article/detail/'+item.id"><img :src="base_url+item.cover.url" style="width: 250px;height: 150px;">
              <p>{{item.desc}}</p>
              <span>立即查看</span></a>
          </div>
        </div>
      </div>

      <div class="hyxw col-lg-10  col-xl-7">
        <div class="tit2">
        <span v-for="(item,index) in banner1.middleNavs" :key="item.id" :class="'ys'+(index+1)+' '+item.active"
              @mouseenter="handleHover(item)">
          <a href="javascript:;">{{ item.name }}</a>
        </span>
          <a :href="'/nav/list/'+middlePNavId" class="more">
            <div class="bi bi-arrow-right-short"></div>
          </a>
        </div>
        <!--  最多6条     -->
        <ul v-for="(item,index) in banner1.middleNavs" :key="item.id" :class="'lb1 ds'+(index+1)+' '+item.cactive" >
          <li v-for="v in item.children" :key="v.id"><a :href="'/article/detail/'+v.id">{{v.desc}}</a><span>{{handleDate(v.published_at) }}</span></li>
        </ul>

      </div>

      <div class="rzxg  col-xl-2 d-none d-lg-block">
        <div class="tit3"><a href="javascript:;" >认证相关</a></div>
        <ul>
          <li class="xg1"><a target="_blank" href="http://cx.cnca.cn/CertECloud/result/skipResultList"><img
              src="">证书查询</a></li>
          <li class="xg2"><a href=""><img
              src="">审核员登录</a></li>
          <li class="xg3"><a href=""><img
              src="">下载中心</a></li>
          <li class="xg4"><a href=""><img
              src="">学习平台</a></li>
        </ul>
      </div>
      <div class="clear"></div>
    </div>
  </div>

<!--  <div class="rzxm container"><a href="">{{ banner2.navTitle }}</a></div>-->

<!--  <div class="swiper-container3 swiper-container-horizontal container">-->

<!--    <swiper-->
<!--        :modules="modules"-->
<!--        :navigation="{ nextEl: '.swiper-next3',  prevEl: '.swiper-prev3'}"-->
<!--        :effect="'slide'"-->
<!--        class="swiper-wrapper3"-->
<!--    >-->
<!--      <swiper-slide v-for="i in banner2.navs" :key="i.id" class="swiper-slide3">-->
<!--        <div>-->
<!--          <div class="rzxm1 container">-->
<!--          <div v-for="(item) in i.fchildren" :key="item.id" class="zrxm2" :style="'background: url('+base_url+item.cover.url+') no-repeat bottom;'">-->

<!--              <h2><a :href="'/article/detail/'+item.id">{{ item.title }}</a></h2>-->
<!--              <p>{{handleStr(item.desc,50)}}</p>-->
<!--              <a class="tshover" :href="'/article/detail/'+item.id">立即查看</a>-->

<!--            </div>-->

<!--                &lt;!&ndash; 最多6条  &ndash;&gt;-->
<!--              <div v-for="item in i.children" :key="item.id" class="rzxm6 bjt10" :style="'background:url('+base_url+item.cover.url+') no-repeat center'">-->
<!--                  <h6><a :href="'/article/detail/'+item.id">{{item.title}}</a></h6>-->
<!--                  <p>{{handleStr(item.desc)}}</p>-->
<!--                  <a class="tshover" :href="'/article/detail/'+item.id">立即查看</a>-->
<!--                </div>-->
<!--                <div class="clear"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </swiper-slide>-->
<!--    </swiper>-->
<!--  </div>-->

<!--  <div class="tc9 container"><a class="swiper-prev3">上一页</a><a class="swiper-next3">下一页</a></div>-->

<!--  <div class="gsjj w1200">
    <div v-for="item in banner3.companyArticle" :key="item.id" class="gsjj1">
      <div class="tit3 w100"><a href="">{{ item.nav.name }}</a></div>
      <div class="gsjj11">
        <a :href="'/article/detail/'+item.id"><img :src="base_url+item.cover.url" style="width: 250px;height: 150px;">
        <p>{{item.desc}}</p>
        <span>查看更多</span></a>
      </div>
    </div>

    <div class="gsjj2">
      <div class="tit3 w100"><a href="">走进华测</a></div>
      <ul>
        <li v-for="item in banner3.navs" :key="item.id"><a :href="'/nav/list/'+item.id">
          <i><img :src="base_url+item.icon.url"></i><span>{{ item.name }}</span></a>
        </li>
        <div class="clear"></div>
      </ul>
    </div>

    <div class="gsjj3">
      <div class="tit3 w100"><a href="http://beijing.hyrzzx.com/zjhy/">走进华测</a></div>
      <div class="kk1">
        <ul class="gssl1">
          <li  v-for="(item,index) in banner3.carousels" :key="item.id" :class="'yss'+(index+1)+' '+item.active" @mouseenter="handleHover2(item)" >{{ item.name }}</li>
        </ul>
        <div v-for="(item,index) in banner3.carousels" :key="item.id" :class="'zl1 '+'dss'+(index+1)+' '+item.cactive">
          <p>{{item.content}} </p>
          <img :src="base_url+item.img_url.url">
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="clear"></div>
  </div>-->
  <div class="module-title container">认证产品</div>
  <div class="module-body container">
    <div class="row">
      <div v-for="v in certProducts" :key="v.id" class="col-lg-3 col-md-4 col-xs-6 module-wrap">
        <div class="module-item">
          <div class="module-img">
            <a :href="'/certPro/detail/'+v.id">
              <img :src="base_url+v.cover.url" alt="" class="img-responsive">
            </a>
          </div>
          <div class="module-info">
            <a :href="'/certPro/detail/'+v.id" class="module-link">
              {{v.title}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="yqlj container">成功案例</div>
  <div class="yqlj1 container">
    <div class="roll-wrap roll_row" id="b">
      <p class="temp">华测益诚帮助我们将健康，安全和环境的数据整合到同一系统的能力，这可以大大帮我们节省时间和费用，进而极大地优化我们的管理流程</p>
<!--      <ul class="roll__list" style="position: absolute; left: 0px; top: 0px;">
        <li><a href="" target="_blank"><img src="" border="0"></a> </li>
        <li><a href="" target="_blank"><img src="" border="0"></a> </li>
        <li><a href="" target="_blank"><img src="" border="0"></a> </li>
        <li><a href="" target="_blank"><img src="" border="0"></a> </li>
        <li><a href="" target="_blank"><img src="" border="0"></a> </li>
      </ul>
      <a class="control pre" href="javascript:;">&lt;</a> <a class="control next" href="javascript:;">&gt;</a> -->
    </div>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.min.css'
import {Navigation, Pagination, Autoplay, Scrollbar } from "swiper"
import {getArticles,getNavs,getContentCarousels,getCertProducts} from "@/api/home";
import {getFormatDate,getFormatStr} from "@/utils"


export default {
  setup() {
    return {
      modules: [Navigation, Pagination, Autoplay,Scrollbar],
    }
  },
  data(){
    return {
      base_url:process.env.VUE_APP_BASE_API,
      newsNavId:5,
      middlePNavId:4,
      banner1:{
        leftData:[],
        middleNavs:[],
        middleArticles:[]
      },
      banner2:{
        navId:9,
        navTitle:'认证项目',
        navs:[],
      },
      banner3:{
        pNavId:2,
        navs:[],
        companyNaveId:3,
        companyArticle:[],
        carousels:[]
      },
      certProducts:[]
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList(){
      const promise = []
      promise.push(new Promise((resolve)=>{
        const temp = {nav:this.newsNavId}
        getArticles(temp).then((response)=>{
          this.banner1.leftData = response
          resolve()
        })
      }))

      promise.push(new Promise((resolve)=>{
        const temp2={parent_id:this.middlePNavId,_limit:3}
        getNavs(temp2).then((response)=>{
          this.banner1.middleNavs = response
          this.banner1.middleNavs[0]['active'] = 't22'
          this.banner1.middleNavs[0]['cactive'] = 'on'
          resolve()
        })
      }))

      promise.push(new Promise((resolve)=>{
        const temp6={parent_id:this.banner2.navId}
        getNavs(temp6).then((response)=>{
          this.banner2.navs = response
          resolve()
        })
      }))

      promise.push(new Promise((resolve)=>{
        const temp7={parent_id:this.banner3.pNavId}
        getNavs(temp7).then((response)=>{
          this.banner3.navs = response.filter((v)=>{
            if([this.newsNavId,this.banner3.companyNaveId].includes(v.id)) return false
            return true
          })
          resolve()
        })
      }))

      promise.push(new Promise((resolve)=>{
        getContentCarousels().then((response)=>{
          this.banner3.carousels = response
          resolve()
        })
      }))

      Promise.all([...promise]).then(()=>{
        let temp3 = []
        this.banner1.middleNavs.map((v)=>{temp3.push(v.id)})
        this.banner2.navs.map((v)=>{temp3.push(v.id)})
        temp3.push(this.banner3.companyNaveId)
        const temp4 = {nav:temp3}
        getArticles(temp4).then((response)=>{
         const temp5 = response
          this.banner1.middleNavs.map((v,i)=>{
            this.banner1.middleNavs[i]['children'] = temp5.filter((value)=>{
              if(value.nav.id === v.id) return true
            })
            this.banner1.middleNavs[i]['children'] = this.banner1.middleNavs[i]['children'].reverse()
            this.banner1.middleNavs[i]['children'] = this.banner1.middleNavs[i]['children'].slice(0,6)
          })

          const temp6 = temp5.reverse()
          this.banner2.navs.map((v,i)=>{
            this.banner2.navs[i]['children'] = temp6.filter((value)=>{
              if(value.nav.id === v.id) return true
            })
            this.banner2.navs[i]['children'] = this.banner2.navs[i]['children'].slice(1,6)
          })

          //得再循环一次,否则视图中获取值不正常
          this.banner2.navs.map((v,i)=>{
            this.banner2.navs[i]['fchildren'] = temp6.filter((value)=>{
              if(value.nav.id === v.id) return true
            })
            this.banner2.navs[i]['fchildren'] = this.banner2.navs[i]['fchildren'].slice(0,1)
          })

          this.banner3.companyArticle = temp5.filter((value)=>{
            if(value.nav.id === this.banner3.companyNaveId) return true
          })
          this.banner3.carousels[0]['active'] = 'in'
          this.banner3.carousels[0]['cactive'] = 'on'
        })
      })

      getCertProducts([]).then((response)=>{
        this.certProducts = response
      })

    },
    async getSpecialData(pNavId,nLimit=3,aLimit=6,cbfunc){
      //获取特定数据,每个分类下获取固定片数文章

      const temp = {parent_id:pNavId,_limit:nLimit}
      const navs =  await getNavs(temp)
      navs.map((v)=>{
          console.log('v',v)
          console.log('aLimit',aLimit)
          console.log('cbfunc',cbfunc)
      })

     /* Promise.all([...promise]).then(()=>{
        pNavs.map((v)=>{
          const temp = {nav:v.id,_limit:aLimit}
          getArticles(temp).then((response)=>{
            console.log('response',response)
            cbfunc()
          })
        })

      })*/

    },
    handleHover(item){
      this.banner1.middleNavs.map((v)=>{
        if(v.id===item.id){
          item['active'] = 't22'
          item['cactive'] = 'on'
        }else{
          v['active'] = ''
          v['cactive'] = ''
        }
      })
    },
    handleHover2(item){
      this.banner3.carousels.map((v)=>{
        if(v.id===item.id){
          item['active'] = 'in'
          item['cactive'] = 'on'
        }else{
          v['active'] = ''
          v['cactive'] = ''
        }
      })
    },
    handleDate(n){
      return getFormatDate('day',n)
    },
    handleStr(n,l){
      return getFormatStr(n,l)
    }
  }
}
</script>
<style scoped>
.temp{
  padding: 1rem 0;
  line-height: 1.35;
  font-size: 1.6rem;
  text-align: left;
}
</style>